import { Film } from "lucide-react";
import { mediaUrl } from "@/lib/api";

export const VideoSlot = ({ slot, label, testid }) => (
  <div className="panel p-5" data-testid={testid}>
    <h3 className="text-xl font-black mb-3">{label}</h3>
    {slot && slot.status === "ready" ? (
      <video className="w-full aspect-video bg-black" src={mediaUrl(slot.url)} controls data-testid={`${testid}-video`} />
    ) : (
      <div className="relative aspect-video bg-[#0b0c0c] flex flex-col items-center justify-center scanlines overflow-hidden text-white">
        <Film size={44} className="text-white/50 mb-4" />
        <div className="font-mono text-2xl tracking-[0.3em]" data-testid={`${testid}-pending`}>FOOTAGE PENDING</div>
        <div className="font-mono text-sm text-white/60 mt-2 tracking-wider">RECOVERED REEL NOT YET DIGITISED</div>
        <span className="absolute top-3 left-4 font-mono text-xs text-white/60">CAM / C3-{(slot && slot.slot) || "--"}</span>
      </div>
    )}
  </div>
);
